export var EUserCapability;
(function (EUserCapability) {
    EUserCapability["AI_ASSISTANT"] = "AI_ASSISTANT";
})(EUserCapability || (EUserCapability = {}));
